export const MB = 1000000;
